<template>
	<div>
		<template v-if="type == 'mobile'">
			<div class="py-4 border-semi-grey radius-12">
				<div class="px-3 mb-3 text-center">
					<p class="heading-6 mb-0">{{data.merchant_pos.tagline}}</p>
	    		<p class="body-2-2-1">{{data.merchant_pos.sub_tagline}}</p>
				</div>
				<div class="w-100 mb-3" v-if="data.merchant_pos.slider.length == 1" style="height: 189px !important;">
          <img :src="data.merchant_pos.slider[0].image_url" class="img-fit" height="189">
        </div>
    		<div v-if="data.merchant_pos.slider.length > 1" class="pl-3 mb-3">
	    		<flickity ref="flickity" :options="$freeScrollSliderOption">
			      <div class="carousel-cell w-90 mr-3" :id="slide.id" v-for="slide in  data.merchant_pos.slider">
			        <div class="w-100" style="height: 189px !important;">
			          <img :src="slide.image_url" class="img-fit radius-6" height="189">
			        </div>
			      </div>
			    </flickity>
			  </div>
			  <div class="pl-3 mb-3" v-if="data.best_menu.product.length > 0">
			  	<div class="mb-3">
				  	<p class="body-1-2 mb-0">{{data.best_menu.tagline}}</p>
		    		<p class="body-2-2-1">{{data.best_menu.sub_tagline}}</p>
		    	</div>
		    	<div class="w-100">
		    		<flickity ref="flickity2" :options="$freeScrollSliderOption">
		    			<div class="carousel-cell product-small-wrapper mr-3" :id="best_product.id" v-for="best_product in data.best_menu.product">
		    				<div class="product-small mb-2">
		    					<img :src="best_product.cover_image_url" class="img-fit radius-6" />
		    				</div>
		    				<p class="body-2-1 mb-0 text-truncate">{{best_product.name}}</p>
		    				<p class="body-2-2 text-orange mb-0">{{$formatCurrency(best_product.price_sell)}}</p>
		    			</div>
		    		</flickity>
		    	</div>
			  </div>
			  <div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table" @click="goToDetail">
		    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.room-dining.see-more-our-menu')}}</p>
      		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
		    </div>
			</div>
		</template>
		<template v-if="type == 'desktop'">
			<div class="py-4 border-semi-grey radius-12">
				<div class="px-4 mb-3">
					<p class="heading-6 mb-0">{{data.merchant_pos.tagline}}</p>
	    		<p class="body-2-2-1">{{data.merchant_pos.sub_tagline}}</p>
				</div>
				<div class="w-100 mb-4 px-3" v-if="data.merchant_pos.slider.length == 1" style="height: 189px !important;">
          <img :src="data.merchant_pos.slider[0].image_url" class="img-fit" height="189">
        </div>
    		<div v-if="data.merchant_pos.slider.length > 1" class="pl-4 mb-4">
	    		<flickity ref="flickity" :options="$freeScrollSliderOption">
			      <div class="carousel-cell w-75 mr-4" :id="slide.id" v-for="slide in  data.merchant_pos.slider">
			        <div class="w-100" style="height: 189px !important;">
			          <img :src="slide.image_url" class="img-fit radius-6" height="189">
			        </div>
			      </div>
			    </flickity>
			  </div>
			  <div class="pl-4" v-if="data.best_menu.product.length > 0">
			  	<div class="row no-gutters mb-4">
			  		<div class="col-8 align-self-center">
			  			<p class="body-1-2 mb-0">{{data.best_menu.tagline}}</p>
		    			<p class="body-2-2-1 mb-0">{{data.best_menu.sub_tagline}}</p>
			  		</div>
			  		<div class="col-4 align-self-center">
			  			<div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table" @click="goToDetail">
					    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">See more our menu</p>
			      		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
					    </div>
			  		</div>
			  	</div>
		    	<div class="w-100">
		    		<flickity ref="flickity2" :options="$freeScrollSliderOption">
		    			<div class="carousel-cell product-big-wrapper mr-3" :id="best_product.id" v-for="best_product in data.best_menu.product">
		    				<div class="product-big mb-2">
		    					<img :src="best_product.cover_image_url" class="img-fit radius-6" />
		    				</div>
		    				<p class="body-2-1 mb-0 text-truncate">{{best_product.name}}</p>
		    				<p class="body-2-2 text-orange mb-0">{{$formatCurrency(best_product.price_sell)}}</p>
		    			</div>
		    		</flickity>
		    	</div>
			  </div>
			</div>
		</template>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'

	export default{
		props:['type','data'],
		components:{
			Flickity
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		methods:{
			goToDetail(){
				this.$postLog('HOME','MODULE PREVIEW',`Clicked detail ${this.data.merchant_pos.code}`)
				this.$router.push(`/${this.getMerchant.code}/concierge/room-dining`)
			}
		}
	}
</script>
<style>
	.product-small{
		width:100px;
		height:100px;
	}
	.product-small-wrapper{
		width:100px;
	}
	.product-big{
		width:230px;
		height:164px;
	}
	.product-big-wrapper{
		width:230px;
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/general/RoomDiningPreview.vue